import React from 'react';
import { SimData } from 'src/common/components/Sim/constants/sim';
import { TagsCell } from './TagsCell';

type TagsCellProps = {
  row: SimData;
};

export const SimTagsCell: React.FC<TagsCellProps> = React.memo(({ row }) => {
  return <TagsCell tags={row.tags?.items} hasMore={row.tags?.hasMore || false} id={row.iccid} />;
});
